import styled from "@emotion/styled";

import InteractiveItem from "./img-interactive-item.svg";
import Item from "./img-item.svg";

export const StyledInteractiveItem = styled(InteractiveItem)`
  inline-size: 200px;
`;

export const StyledItem = styled(Item)`
  inline-size: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 1208px;
  max-inline-size: 100%;
  margin-inline: auto;
`;

export const Columns = styled.div`
  display: flex;
  gap: 40px;

  margin-block-start: 54px;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`;
